import {
  Component,
  inject,
} from '@angular/core';
import {ViewportScroller} from '@angular/common';
import {TranslatePipe} from '@ngx-translate/core';
import {FooterInfoComponent} from '../../components/footer-info/footer-info.component';
import {HeaderComponent} from '../../components/header/header.component';
import {ContentSectionsComponent} from '../../components/content-sections/content-sections.component';
import {HtmlContentComponent} from '../../components/html-content/html-content.component';
import {BackButtonComponent} from '../../components/back-button/back-button.component';
import {PageTitleComponent} from '../../components/page-title/page-title.component';
import {CommonSpacerComponent} from '../../components/common-spacer/common-spacer.component';

@Component({
  selector: 'app-bvg',
  imports: [FooterInfoComponent, HeaderComponent, ContentSectionsComponent,
    TranslatePipe, HtmlContentComponent, BackButtonComponent, PageTitleComponent, CommonSpacerComponent],
  templateUrl: './bvg.component.html',
  styleUrl: './bvg.component.scss',
})
export class BvgComponent {

  private viewportScroller: ViewportScroller = inject(ViewportScroller);

  constructor() {
    this.viewportScroller.scrollToPosition([0, 0]);
  }

}
